/** Placeholder palette shared by the renderer and the HUD. Swap freely when real art lands. */
import type { NpcTier, ResourceId, Role, School } from '@keystone/sim';

export const ROLE_COLOR: Record<Role, string> = {
  tank: '#4a8fe7',
  healer: '#52c96e',
  dps: '#e8a23a',
};

export const ENEMY_TIER_COLOR: Record<NpcTier, string> = {
  fodder: '#b06a5c',
  standard: '#c0473b',
  caster: '#a24ac4',
  big: '#a8322a',
  miniboss: '#d0402a',
  boss: '#e02c4c',
};

export const SCHOOL_COLOR: Record<School, string> = {
  physical: '#e9dcc4',
  holy: '#ffe58a',
  fire: '#ff7a2e',
  nature: '#7be06a',
  frost: '#7fd2ff',
  shadow: '#b07cff',
  arcane: '#ff8cf0',
};

export const RESOURCE_COLOR: Record<string, string> = {
  mana: '#3d7bff',
  rage: '#d63b3b',
  resolve: '#3fc3b0',
  maelstrom: '#3aa0ff',
  holy_power: '#f5d04a',
  voltage: '#5b8cff', // +mage-specs
  spines: '#9ee4ff',
  cinders: '#ff7a2e',
  tithes: '#a46cff', // +acolyte-specs: the Heretic's Tithes
  rounds: '#d9a24a', // +ranger-specs: the Deadeye's Cylinder
  bond: '#ff9a3a', // +ranger-specs: the Beastbound's Bond
};

export const resourceColor = (id: ResourceId): string => RESOURCE_COLOR[id] ?? '#aaaaaa';

/** Size scale of NPC capsules by tier (bosses are big). */
export const TIER_SCALE: Record<NpcTier, number> = {
  fodder: 0.8,
  standard: 1,
  caster: 1,
  big: 1.35,
  miniboss: 1.6,
  boss: 2.2,
};

export function unitColor(u: { faction: string; role: Role | null; tier: NpcTier | null }): string {
  if (u.faction === 'party') return u.role ? ROLE_COLOR[u.role] : '#cccccc';
  return u.tier ? ENEMY_TIER_COLOR[u.tier] : ENEMY_TIER_COLOR.standard;
}
